export default {
  "menu.welcome": "欢迎",
  "menu.home": "首页",
  "menu.login": "登录",
  "menu.register": "注册",
  "menu.register-result": "注册结果",

  // Dashboard
  "menu.dashboard": "数据看板",
  "menu.dashboard.workplace": "工作台",
  "menu.dashboard.business-data": "经营数据",
  "menu.dashboard.device-monitor": "设备监控",
  "menu.workplace": "工作台",
  "menu.business-data": "经营数据",
  "menu.device-monitor": "设备监控",

  // 经营管理
  "menu.management": "经营管理",
  "menu.management.store": "门店管理",
  "menu.management.product": "商品管理",
  "menu.management.room": "雅间管理",
  "menu.management.set-meal": "套餐管理",

  // 人员管理
  "menu.personnel": "人员管理",
  "menu.personnel.employee": "员工管理",
  "menu.personnel.member": "会员管理",

  // 交易管理
  "menu.transaction": "交易管理",
  "menu.transaction.orders": "订单管理",
  "menu.transaction.orders.orders-user": "用户订单",
  "menu.transaction.orders.orders-invoice": "发票管理",
  "menu.transaction.coupon": "优惠券管理",
  "menu.transaction.coupon.coupon-templates": "优惠券模板",
  "menu.transaction.coupon.user-coupons": "已售优惠券",

  // 运营配置
  "menu.content": "运营配置",
  "menu.content.news": "动态管理",
  "menu.content.miniapp-config": "小程序配置",
  "menu.content.member-level": "会员等级",

  // 参考组件
  "menu.reference": "参考组件",

  // 列表参考
  "menu.list-ref": "列表参考",
  "menu.table-list": "查询表格",
  "menu.basic-list": "标准列表",
  "menu.card-list": "卡片列表",
  "menu.search-list": "搜索列表",
  "menu.articles": "搜索列表（文章）",
  "menu.projects": "搜索列表（项目）",
  "menu.applications": "搜索列表（应用）",

  // 表单参考
  "menu.form-ref": "表单参考",
  "menu.basic-form": "基础表单",
  "menu.step-form": "分步表单",
  "menu.advanced-form": "高级表单",

  // 详情参考
  "menu.profile-ref": "详情参考",
  "menu.basic-profile": "基础详情页",
  "menu.advanced-profile": "高级详情页",

  // 结果参考
  "menu.result-ref": "结果参考",
  "menu.success": "成功页",
  "menu.fail": "失败页",

  // 异常参考
  "menu.exception-ref": "异常参考",
  "menu.err403": "403",
  "menu.err404": "404",
  "menu.err500": "500",

  // 嵌套菜单完整路径
  "menu.reference.list-ref": "列表参考",
  "menu.reference.list-ref.table-list": "查询表格",
  "menu.reference.list-ref.basic-list": "标准列表",
  "menu.reference.list-ref.card-list": "卡片列表",
  "menu.reference.list-ref.search-list": "搜索列表",
  "menu.reference.list-ref.search-list.articles": "搜索列表（文章）",
  "menu.reference.list-ref.search-list.projects": "搜索列表（项目）",
  "menu.reference.list-ref.search-list.applications": "搜索列表（应用）",
  "menu.reference.form-ref": "表单参考",
  "menu.reference.form-ref.basic-form": "基础表单",
  "menu.reference.form-ref.step-form": "分步表单",
  "menu.reference.form-ref.advanced-form": "高级表单",
  "menu.reference.profile-ref": "详情参考",
  "menu.reference.profile-ref.basic-profile": "基础详情页",
  "menu.reference.profile-ref.advanced-profile": "高级详情页",
  "menu.reference.result-ref": "结果参考",
  "menu.reference.result-ref.success": "成功页",
  "menu.reference.result-ref.fail": "失败页",
  "menu.reference.exception-ref": "异常参考",
  "menu.reference.exception-ref.err403": "403",
  "menu.reference.exception-ref.err404": "404",
  "menu.reference.exception-ref.err500": "500",
};
